import { render, staticRenderFns } from "./CurrentUnavailableProducts.vue?vue&type=template&id=60523b27&scoped=true&"
import script from "./CurrentUnavailableProducts.vue?vue&type=script&lang=js&"
export * from "./CurrentUnavailableProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60523b27",
  null
  
)

export default component.exports